import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';
import { AppService } from './app.service';

declare const DD_LOGS: any; // Declare global Datadog object

@Injectable({
  providedIn: 'root'
})
export class DatadogLoggingService {
  constructor(private appService: AppService) {
    this.appService.fetchBackendEndpoints();
    if (typeof DD_LOGS !== 'undefined' && DD_LOGS.init) {
      DD_LOGS.init({
        clientToken: 'pubd88abf375ed6f92da6c23cae43f01de0',
        site: 'us3.datadoghq.com',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        forwardConsoleLogs: ['error', 'warn', 'info'],
        service: 'orderai-ui-tablet-hub',
        env: 'prod'
      });

      this.logInfo('App initialized and backend endpoints all set!');
    } else {
      console.error('Datadog Logs SDK not available.');
    }
    this.logInfo('App initialized and backend endpoints all set!');
  }

  logInfo(message: string, context?: object) {
    console.log('datadog log');
    DD_LOGS.logger.info(message, context);
  }

  logError(message: string, context?: object) {
    DD_LOGS.logger.error(message, context);
  }

  logWarn(message: string, context?: object) {
    DD_LOGS.logger.warn(message, context);
  }

  logDebug(message: string, context?: object) {
    DD_LOGS.logger.debug(message, context);
  }
}
